import styled from 'styled-components';

export const CardWrapper = styled.div.attrs({ className: 'card' })``;
export const CardBody = styled.div.attrs({ className: 'cardBody' })``;
export const CardTitle = styled.div.attrs({
  className: 'font-semibold text-gray-800 text-lg mb-4',
})``;

export const CardAside = styled.aside``;
export const CardMain = styled.main``;
